import { useSceneStore } from '../state/sceneStore';

/**
 * Design and align render clouds for the same sensor ids, and their effects can
 * interleave, so each mode tracks its own namespace of the shared progress state.
 */
export type CloudLoadScope = 'design' | 'align';

function cloudLoadKey(scope: CloudLoadScope, cloudId: string): string {
  return `${scope}:${cloudId}`;
}

export function resetCloudLoadingScope(scope: CloudLoadScope): void {
  useSceneStore.getState().clearCloudLoadingScope(scope);
}

export function registerCloudPending(scope: CloudLoadScope, cloudId: string): void {
  useSceneStore.getState().registerCloudPending(cloudLoadKey(scope, cloudId));
}

export function registerCloudReady(scope: CloudLoadScope, cloudId: string): void {
  useSceneStore.getState().registerCloudReady(cloudLoadKey(scope, cloudId));
}

export function unregisterCloud(scope: CloudLoadScope, cloudId: string): void {
  useSceneStore.getState().unregisterCloud(cloudLoadKey(scope, cloudId));
}
